import { useMutation } from '@tanstack/react-query';
import api from '../api';
import type { ApiErrorResponse, ApiResponse } from '../types';
import type { CompleteIterationImagesUploadPayload } from './types';

export const completeIterationImagesUploadRequest = async (
  payload: CompleteIterationImagesUploadPayload,
): Promise<ApiResponse> => {
  const { iterationDatasetId, uploadStatus } = payload;
  return api.post(
    `/processing/iteration-dataset/${iterationDatasetId}/images-upload-complete/`,
    {
      upload_status: uploadStatus,
    },
  );
};

export const useCompleteImageUploadRequest = () =>
  useMutation<
    ApiResponse,
    ApiErrorResponse,
    CompleteIterationImagesUploadPayload
  >({
    mutationFn: async (payload: CompleteIterationImagesUploadPayload) =>
      completeIterationImagesUploadRequest(payload),
  });
